import React from 'react';
import { Card, CardActionArea, CardContent, CardActions, Grid, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const ServiceFeatures = ({ isLargeScreen }) => {
  const theme = useTheme(); // For dynamic theming support

  return (
    <Grid container sx={{ mb: 10}}>
      <Stack spacing={2} direction="row" sx={{ width: '100%', justifyContent: 'space-between' }}>
        <Grid container spacing={2} >
          <Grid item xs={12} lg={2} style={{paddingLeft:'0px'}} >
            <Card
              sx={{
                minWidth: 230,
                background: `#fafafa`,
                boxShadow: 3,
                borderRadius: 2,
                '&:hover': {
                  boxShadow: 8,
                },
              }}
            >
              <CardActionArea>
                <CardContent sx={{ textAlign: 'center' }}>
                  <Typography variant="h6" sx={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#000' }}>
                    Reliable and On-Time
                  </Typography>
                  <img
                    src="/images/login/taxi-service-onlocation.webp"
                    width={100}
                    height={100}
                    alt="Reliable"
                    style={{ marginBottom: '20px' }}
                  />
                  <Typography sx={{ color: '#000' }}>
                    At <strong>SVR Taxi</strong>, punctuality is our priority. We understand the value of your time and
                    strive to ensure that every ride is on schedule.
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>

          <Grid item xs={12} lg={2} gap={2} style={{paddingLeft:'0px'}}>
            <Card
              sx={{
                minWidth: 230,
                background: '#fafafa',
                boxShadow: 3,
                borderRadius: 2,
                '&:hover': {
                  boxShadow: 8,
                },
              }}
            >
              <CardActionArea>
                <CardContent sx={{ textAlign: 'center' }}>
                  <Typography variant="h6" sx={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#000' }}>
                    Experienced Drivers
                  </Typography>
                  <img
                    src="/images/login/Dashboard/Assert/driver.webp"
                    width={100}
                    height={100}
                    alt="Experienced Drivers"
                    style={{ marginBottom: '20px' }}
                  />
                  <Typography sx={{ color: '#000' }}>
                    Our drivers are licensed, experienced, and knowledgeable. They are committed to ensuring your safety
                    and comfort.
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>

          <Grid item xs={12} lg={2} gap={2} style={{paddingLeft:'0px'}}>
            <Card
              sx={{
                minWidth: 230,
                background: `#fafafa`,
                boxShadow: 3,
                borderRadius: 2,
                '&:hover': {
                  boxShadow: 8,
                },
              }}
            >
              <CardActionArea>
                <CardContent sx={{ textAlign: 'center' }}>
                  <Typography variant="h6" sx={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#000' }}>
                    Affordable Rates
                  </Typography>
                  <img
                    src="/images/login/Dashboard/Assert/affortable-price.webp"
                    width={100}
                    height={100}
                    alt="Affordable Rates"
                    style={{ marginBottom: '20px' }}
                  />
                  <Typography sx={{ color: '#000' }}>
                    Enjoy premium taxi service without breaking the bank. SVR Taxi offers competitive pricing for local
                    and long-distance rides.
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>

          <Grid item xs={12} lg={2} gap={2} style={{paddingLeft:'0px'}}>
            <Card
              sx={{
                minWidth: 230,
                background: '#fafafa',
                boxShadow: 3,
                borderRadius: 2,
                '&:hover': {
                  boxShadow: 8,
                },
              }}
            >
              <CardActionArea>
                <CardContent sx={{ textAlign: 'center' }}>
                  <Typography variant="h6" sx={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#000' }}>
                    Clean and Well-Maintained Vehicles
                  </Typography>
                  <img
                    src="/images/login/Dashboard/Assert/back-ground-image.webp"
                    width={100}
                    height={100}
                    alt="Clean Vehicles"
                    style={{ marginBottom: '20px' }}
                  />
                  <Typography sx={{ color: '#000' }}>
                    Our fleet is regularly serviced and cleaned to ensure that you travel in comfort and style.
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>

          <Grid item xs={12} lg={2} gap={2} style={{paddingLeft:'0px'}}>
            <Card
              sx={{
                minWidth: 230,
                background: '#fafafa',
                boxShadow: 13,
                borderRadius: 2,
                
                '&:hover': {
                  boxShadow: 18,
                },
              }}
            >
              <CardActionArea>
                <CardContent sx={{ textAlign: 'center' }}>
                  <Typography variant="h6" sx={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#000' }}>
                    24/7 Availability
                  </Typography>
                  <img
                    src="/images/login/Dashboard/Assert/taxi-service-all-time.webp"
                    width={100}
                    height={100}
                    alt="24/7 Availability"
                    style={{ marginBottom: '20px' }}
                  />
                  <Typography sx={{ color: '#000' }}>
                    Need a ride at any hour? SVR Taxi operates 24/7 to accommodate your schedule. Just give us a call!
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        </Grid>
      </Stack>
    </Grid>
  );
};

export default ServiceFeatures;
